import { InfoOutlined } from "@material-ui/icons";
import {
  Box,
  IconButton,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { LIST_ANSWERED_DURATION, LIST_INBOUND_CALL_STATUS } from "constant";
import moment from "moment";
import { useGetListAgent } from "service/query/agent.query";
import { useGetListContactCenter } from "service/query/common.query";
import { useGetExtensionDetail } from "service/query/extension.query";

const InboundCallExportHistories = ({ record }) => {
  const { data: listContactCenter } = useGetListContactCenter();
  const { data: listAgent } = useGetListAgent({ query: "all" });
  const { data: extension } = useGetExtensionDetail(
    record?.filter?.extensionId
  );

  const extensionName = record.filter.extensionId
    ? `${extension?.name} - ${extension?.username}`
    : null;

  const result = [];
  const contactCenterName = record.filter.contactCode
    ? listContactCenter?.find((item) => item.code === record.filter.contactCode)
        ?.name
    : null;
  const agent = record.filter.agent ? listAgent?.find((item) => item.id) : null;

  const agentName = agent?.user
    ? `${agent.user.username} - ${agent.user.fullname}`
    : null;

  const answeredDuration = `${record.filter.answeredDurationGte ?? ""}-${
    record.filter.answeredDurationLte ?? ""
  }`;

  const answeredDurationLabel = LIST_ANSWERED_DURATION.find(
    (item) => item.value === answeredDuration
  )?.label;
  const statusName = record.filter?.status
    ? LIST_INBOUND_CALL_STATUS.find(
        (item) => item.value === record.filter.status
      )?.label
    : null;

  const fromTime = moment(record.filter.from).format("YYYY-MM-DD HH:mm");
  const endTime = moment(record.filter.to).format("YYYY-MM-DD HH:mm");
  result.push(`Thời gian: ${fromTime} - ${endTime}`);
  result.push(`Số điện thoại gọi: ${record.filter.fromNumber ?? "Tất cả"}`);
  result.push(`Đơn vị tiếp nhận: ${contactCenterName ?? "Tất cả"}`);
  result.push(`Số điện thoại nhận: ${record.filter.toNumber ?? "Tất cả"}`);
  result.push(`Tài khoản: ${agentName ?? "Tất cả"}`);
  result.push(`Trạng thái: ${statusName ?? "Tất cả"}`);
  result.push(`Máy lẻ: ${extensionName ?? "Tất cả"}`);
  result.push(`Nhánh: ${record.filter.ivrExtension ?? "Tất cả"}`);
  result.push(`Thời lượng trả lời: ${answeredDurationLabel ?? "Tất cả"}`);

  return (
    <Tooltip
      PopperProps={{
        sx: {
          [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: 500,
          },
        },
      }}
      placement="left"
      title={
        <Box sx={{ fontSize: 14 }}>
          {result.map((item, index) => (
            <Typography key={index}>{item}</Typography>
          ))}
        </Box>
      }>
      <IconButton color="default">
        <InfoOutlined />
      </IconButton>
    </Tooltip>
  );
};

export default InboundCallExportHistories;
